import { toNumber } from "../utils";

function getGrossWeightCost(data) {
  let rate = 0;
  if (data?.country_guid === "9B785514-12A9-4336-A927-C36A46596D3D") {
    rate = 999;
  } else if (data?.country_guid === "A4D9A734-CCEC-49AF-A5B5-6D5765639D21") {
    rate = 1100;
  }
  return Number(data?.gross_weight * rate);
}

export function calcShippingCost(order) {
  const w = toNumber(order?.width ?? 0);
  const h = toNumber(order?.height ?? 0);
  const l = toNumber(order?.length ?? 0);
  let g = toNumber(order?.gross_weight ?? 0);

  if ([w, h, l, g].some((v) => v === null || Number.isNaN(v))) {
    return "";
  }

  // фактический вес округляем вверх до 100 грамм
  g = Math.ceil(g * 10) / 10;

  const grossWeightCost =
    Number(getGrossWeightCost({ ...order, gross_weight: g })) || 0;

  // объемный вес округляем вверх до 100 грамм
  const volumeWeight = Math.ceil(((w * h * l) / 6000) * 10) / 10;
  const volumeCost = Math.max(0, volumeWeight - g) * 600;

  // итог вверх до 10 сом
  return Math.ceil((volumeCost + grossWeightCost) / 10) * 10;
}